<template>
        <router-view></router-view>
</template>
<script>
export default {
    data () {
        return {
    
        };
    },
    methods:{
    
    }
}
</script>
<style scoped lang="less">
    
</style>


// WEBPACK FOOTER //
// src/layout/mobile/user.vue